import Vue from 'vue'
import Router from 'vue-router'
import AuthRoutes from '@/routes/common/auth'
import AdminRoutes from '@/routes/admin/admin'
import OnBoardRoutes from '@/routes/on-board/on-board'

import store from './store'
import moment from 'moment'

Vue.use(Router)

const baseRoutes = [
  {
    path: '/',
    name: 'index',
    redirect: function() {
      return '/on-board'
    }
  },
  {
    path: '/shared-docs/:id',
    name: 'onBoard.neofintech.SharedDocs',
    props: true,
    meta: {
      requiresAuth: false,
      hasBottomBar: false
    },
    component: () => import('@/views/on-board/neofintech/SharedDocs.vue')
  },
  {
    path: '/my-neofintech-request/:id/preview-draft-nda',
    name: 'onBoard.neofintech.PreviewDraftNDA',
    props: true,
    meta: {
      requiresAuth: false,
      hasBottomBar: false
    },
    component: () =>
      import(
        /* webpackChunkName: "onboard" */
        '@/views/on-board/neofintech/PreviewDraftNDA.vue'
      )
  },
  {
    path: '/my-neofintech-request/:id/review/:documentType',
    name: 'onBoard.neofintech.reviewRequestDocument',
    props: true,
    meta: {
      requiresAuth: true,
      hasBottomBar: false
    },
    component: () =>
      import(
        /* webpackChunkName: "onboard" */
        '@/views/on-board/neofintech/ReviewDocument.vue'
      )
  },
  {
    path: '/earth',
    name: 'earth',
    meta: {
      prev: null,
      next: null,
      name: null,
      hasBottomBar: false
    },
    component: () =>
      import(
        /* webpackChunkName: "tests" */
        '@/views/Earth.vue'
      )
  }
]

const routes = baseRoutes.concat(OnBoardRoutes, AdminRoutes, AuthRoutes)

const router = new Router({
  mode: 'history',
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

router.beforeResolve((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
      .then(function(user) {
        if (user.attributes['custom:expiration_date']) {
          const isExpired = moment(
            user.attributes['custom:expiration_date'],
            'DD/MM/YYYY'
          ).isBefore(moment())
          if (isExpired) {
            next({
              path: '/a/expired'
            })
          }
        } else {
          next()
        }
      })
      .catch(() => {
        store.commit('SET_NEXT_ROUTE', to)
        next({
          path: '/sign-in'
        })
      })
  }
  next()
})

export default router
